export const NAME = 'coverages-config';
export const TAX_TYPES = {
    PERCENTAGE: 'percentaje_tax',
    AMOUNT: 'amount_tax',
};
